export enum LayoutSelection {
  LIST = 'List',
  GRID = 'Grid',
}

export const LayoutOptions = [LayoutSelection.LIST, LayoutSelection.GRID];

export enum SubscriptionLevel {
  FREE = 'FREE',
  PLUS = 'PLUS',
  PRO = 'PRO',
}

export enum SubscriptionSongAmount {
  FREE = 10,
  PLUS = 100,
  PRO = Number.MAX_VALUE,
}

export function formatSongKey(key: string, keyScale: string) {
  if (!key) return;

  const shortenedKeyScale = keyScale === 'major' ? '' : 'm';

  if (key.includes('b')) {
    return key[0] + '♭' + shortenedKeyScale;
  } else if (key.includes('#')) {
    return key[0] + '♯' + shortenedKeyScale;
  } else {
    return key + shortenedKeyScale;
  }
}

export function getDefaultArtworkCss(id: number) {
  return id === undefined ? 'defaultArtwork-1' : 'defaultArtwork-' + id;
}

export function getDefaultArtworkImage(id?: number, size?: string) {
  if (id === undefined) id = 1;
  if (size === undefined) size = 'LG';
  return (
    process.env.VUE_APP_FRONTEND_DOMAIN +
    '/assets/default-artwork/' +
    'DA-' +
    id +
    '-' +
    size +
    '.png'
  );
}
